import { put, all, call, takeLatest } from 'redux-saga/effects';

import types from './actionTypes';
import * as invoicesActions from './actions';

import { getFirestore, collection, query, where } from 'firebase/firestore';
import rsf from '../../helpers/firebase';

import { toDateFirebase } from '../../helpers/sharedFunction';

const db = getFirestore(rsf.app);

const invoiceTransformer = (invoice, data) => ({
  id: invoice.id,
  ...data,
  ...(data.createdAt && {
    createdAt: toDateFirebase(invoice, data).toDate(),
  }),
});

function* fetchInvoicesByUserSaga({ userId }) {
  try {
    const invoicesRef = query(
      collection(db, 'invoices'),
      where('userId', '==', userId),
    );
    const invoicesSnap = yield call(rsf.firestore.getCollection, invoicesRef);
    const invoices = invoicesSnap.docs.map((snap) =>
      invoiceTransformer(snap, snap.data()),
    );

    yield put(invoicesActions.fetchInvoicesByUserSuccess(invoices));
  } catch (error) {
    yield put(invoicesActions.fetchInvoicesByUserFailure(error));
  }
}

function* subscriptionSaga() {
  yield all([
    takeLatest(types.FETCH_INVOICES_BY_USER.REQUEST, fetchInvoicesByUserSaga),
  ]);
}

export default subscriptionSaga;
